import { render, staticRenderFns } from "./PageCategoryAdd.vue?vue&type=template&id=b66a262c"
import script from "./PageCategoryAdd.vue?vue&type=script&lang=js"
export * from "./PageCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports